import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

const defaultFormatter = (notification: number) => String(notification);

type Props = {
    className?: string;
    icon?: IconTypes;
    show?: boolean;
    notification?: number;
    formatter?: (notification: number) => string;
};

const PanelArrow: React.FC<Props> = ({
    className,
    icon = IconTypes.PIL_HOEYRE,
    show = true,
    notification,
    formatter = defaultFormatter,
}) =>
    show ? (
        <span
            className={classNames('sgw-link-panel__arrow-wrapper', className, {
                'with-notification': typeof notification === 'number' && notification > 0,
            })}
        >
            {typeof notification === 'number' && notification > 0 && (
                <span className="sgw-link-card__notification-badge">{formatter(notification)}</span>
            )}
            <Icon type={icon} />
        </span>
    ) : null;

export default PanelArrow;
